import { render } from "./soal_menjodohkan.vue?vue&type=template&id=34e8a3b5&scoped=true"
import script from "./soal_menjodohkan.vue?vue&type=script&lang=js"
export * from "./soal_menjodohkan.vue?vue&type=script&lang=js"

import "./soal_menjodohkan.vue?vue&type=style&index=0&id=34e8a3b5&scoped=true&lang=css"
import "./soal_menjodohkan.vue?vue&type=style&index=1&id=34e8a3b5&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e8a3b5"]])

export default __exports__